import MapButton from 'components/buttons/MapButton';
import FlightPathIcon from 'components/icons/FlightPathIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleFlightPathsButton: FunctionComponent<Props> = ({
    className = '',
    isActive = true,
    onClick,
    testId = TEST_ID
}) => {
    const inactiveClass = isActive ? '' : styles.inactive;

    return (
        <MapButton className={`${inactiveClass} ${className}`} onClick={onClick} testId={testId}>
            <FlightPathIcon />
        </MapButton>
    );
};

export default ToggleFlightPathsButton;
